import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  alignClipsResponseDL: {},
  alignClipsResponseWS: {},
  combineClipsResponse: {},
  importErrorMessage: "",
  stoiFailedResponse: {},
  showAlignClipsSnackbarDL: false,
  showAlignClipsSnackbarWS: false,
  showCombineClipsSnackbar: false,
  showImportErrorSnackbar: false,
  showStoiFailedSnackbar: false,
  showUploadingSnackbar: false,
};

const snackbarSlice = createSlice({
  name: "snackbars",
  initialState,
  reducers: {
    openAlignClipsSnackbarDL: (state, action) => {
      state.showAlignClipsSnackbarDL = true;
      state.alignClipsResponseDL = action.payload;
    },
    closeAlignClipsSnackbarDL: (state, _action) => {
      state.showAlignClipsSnackbarDL = false;
    },
    clearAlignClipsResponseDL: (state, _action) => {
      state.alignClipsResponseDL = {};
    },
    openAlignClipsSnackbarWS: (state, action) => {
      state.showAlignClipsSnackbarWS = true;
      state.alignClipsResponseWS = action.payload;
    },
    closeAlignClipsSnackbarWS: (state, _action) => {
      state.showAlignClipsSnackbarWS = false;
    },
    clearAlignClipsResponseWS: (state, _action) => {
      state.alignClipsResponseWS = {};
    },
    openCombineClipsSnackbar: (state, action) => {
      state.showCombineClipsSnackbar = true;
      state.combineClipsResponse = action.payload;
    },
    closeCombineClipsSnackbar: (state, _action) => {
      state.showCombineClipsSnackbar = false;
    },
    clearCombineClipsResponse: (state, _action) => {
      state.combineClipsResponse = {};
    },
    openImportErrorSnackbar: (state, action) => {
      state.showImportErrorSnackbar = true;
      state.importErrorMessage = action.payload;
    },
    closeImportErrorSnackbar: (state, _action) => {
      state.showImportErrorSnackbar = false;
    },
    clearImportErrorMessage: (state, _action) => {
      state.importErrorMessage = "";
    },
    openUploadingSnackbar: (state, _action) => {
      state.showUploadingSnackbar = true;
    },
    closeUploadingSnackbar: (state, _action) => {
      state.showUploadingSnackbar = false;
    },
    openStoiFailedSnackbar: (state, action) => {
      state.showStoiFailedSnackbar = true;
      state.stoiFailedResponse = action.payload;
    },
    closeStoiFailedSnackbar: (state, _action) => {
      state.showStoiFailedSnackbar = false;
    },
    clearStoiFailedResponse: (state, _action) => {
      state.stoiFailedResponse = {};
    },
    toggleUploadingSnackbar: (state, _action) => {
      state.showUploadingSnackbar = !state.showUploadingSnackbar;
    },
  },
});

export const {
  openAlignClipsSnackbarDL,
  closeAlignClipsSnackbarDL,
  clearAlignClipsResponseDL,
  openAlignClipsSnackbarWS,
  closeAlignClipsSnackbarWS,
  clearAlignClipsResponseWS,
  closeCombineClipsSnackbar,
  openCombineClipsSnackbar,
  clearCombineClipsResponse,
  openImportErrorSnackbar,
  closeImportErrorSnackbar,
  clearImportErrorMessage,
  closeStoiFailedSnackbar,
  openStoiFailedSnackbar,
  clearStoiFailedResponse,
  closeUploadingSnackbar,
  openUploadingSnackbar,
  toggleUploadingSnackbar,
} = snackbarSlice.actions;

export default snackbarSlice.reducer;
